import React from 'react';
import { ClipboardList, Clock, Building2, CheckCircle2 } from 'lucide-react';

interface Props {
  total: number;
  totalDuration: number;
  uniqueClients: number;
  completedCount: number;
  formatDuration: (min: number) => string;
}

export default function ReportKPICards({ total, totalDuration, uniqueClients, completedCount, formatDuration }: Props) {
  const completionRate = total > 0 ? Math.round((completedCount / total) * 100) : 0;

  const cards = [
    {
      id: 'kpi-total',
      label: 'Ukupno intervencija',
      value: String(total),
      icon: <ClipboardList size={20} />,
      bg: 'hsl(217 91% 60% / 0.08)',
      iconColor: 'hsl(var(--accent))',
      valueSuffix: '',
    },
    {
      id: 'kpi-duration',
      label: 'Ukupno vreme',
      value: formatDuration(totalDuration),
      icon: <Clock size={20} />,
      bg: 'hsl(142 71% 45% / 0.08)',
      iconColor: 'hsl(142 71% 38%)',
      valueSuffix: '',
    },
    {
      id: 'kpi-clients',
      label: 'Klijenata u periodu',
      value: String(uniqueClients),
      icon: <Building2 size={20} />,
      bg: 'hsl(38 92% 50% / 0.10)',
      iconColor: 'hsl(38 80% 40%)',
      valueSuffix: '',
    },
    {
      id: 'kpi-completion',
      label: 'Stopa završenosti',
      value: `${completionRate}%`,
      icon: <CheckCircle2 size={20} />,
      bg: completionRate >= 90 ? 'hsl(142 71% 45% / 0.08)' : 'hsl(38 92% 50% / 0.10)',
      iconColor: completionRate >= 90 ? 'hsl(142 71% 38%)' : 'hsl(38 80% 40%)',
      valueSuffix: ` (${completedCount}/${total})`,
    },
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {cards.map(card => (
        <div key={card.id} className="card p-5">
          <div className="flex items-start justify-between mb-3">
            <p
              className="text-xs font-semibold uppercase tracking-wide"
              style={{ color: 'hsl(var(--muted-foreground))', letterSpacing: '0.06em' }}
            >
              {card.label}
            </p>
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: card.bg, color: card.iconColor }}
            >
              {card.icon}
            </div>
          </div>
          <p
            className="text-3xl font-bold tabular-nums"
            style={{ color: 'hsl(var(--foreground))' }}
          >
            {card.value}
          </p>
          {card.valueSuffix && (
            <p className="text-xs mt-1" style={{ color: 'hsl(var(--muted-foreground))' }}>
              {card.valueSuffix}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}